import { ArrowDown, ArrowsDownUp, ArrowUp } from "@phosphor-icons/react";
import type { Apartment } from "@/api/districts/types";

export type SortField = "street";
export type SortDir = "asc" | "desc";

interface SortIconProps {
	field: SortField;
	sortField: SortField | null;
	sortDir: SortDir;
}

export function SortIcon({ field, sortField, sortDir }: SortIconProps) {
	if (sortField !== field)
		return (
			<ArrowsDownUp
				className="size-3.5 shrink-0 opacity-40"
				aria-hidden="true"
			/>
		);
	if (sortDir === "asc")
		return <ArrowUp className="size-3.5 shrink-0" aria-hidden="true" />;
	return <ArrowDown className="size-3.5 shrink-0" aria-hidden="true" />;
}

export function sortApartments(
	list: Apartment[],
	field: SortField | null,
	dir: SortDir,
): Apartment[] {
	if (!field) return list;
	return [...list].sort((a, b) => {
		const cmp = a[field].localeCompare(b[field], "pl");
		return dir === "asc" ? cmp : -cmp;
	});
}
